export const getThemes = () => {
	const defaultTheme = process.env.NEXT_PUBLIC_DEFAULT_THEME || 'light';
	return [
		...(process.env.NEXT_PUBLIC_THEMES ? [...process.env.NEXT_PUBLIC_THEMES.split(','), defaultTheme] : [defaultTheme])
	].filter((value, index, self) => self.indexOf(value) === index);
}